

export default function Increment({increment, position, deleteClick}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{increment?.nomtable}</td>
            <td>{increment?.prefixe}...</td>
            <td>{increment?.incr}</td>
            <td>{increment.incrdate ? increment?.incrdate.slice(0, 10) : ""}</td>
            {/* <td><ReactTimeAgo date={Date.parse(increment?.datecrea)} timeStyle="facebook" /></td> */}
            <td className="text-center">
                <button  data-toggle="tooltip" title="Delete increment" data-placement="left"
                    onClick={deleteClick}
                    className="btn-shadow-danger mr-2 ml-2 btn btn-sm btn-danger">
                    <i className="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    )
}